
/**
 * 환불 유형
 */
export type GetApiV1RefundsMyRequests200AllOfThreeDataItemRefundType = typeof GetApiV1RefundsMyRequests200AllOfThreeDataItemRefundType[keyof typeof GetApiV1RefundsMyRequests200AllOfThreeDataItemRefundType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiV1RefundsMyRequests200AllOfThreeDataItemRefundType = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  AI_USAGE_BASED: 'AI_USAGE_BASED',
} as const;
